import { Box } from "@mui/material";
import { DotLegalDialog, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";

export interface IAddToAllDataCategoriesDialogProps {
    type: string;
    onConfirm: () => void;
    onDecline: () => void;
    onClose: () => void;
}

function AddToAllDataCategoriesDialog(props: IAddToAllDataCategoriesDialogProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalDialog
            header={translateString("addToAllDataCategoriesHeader", { name: props.type })}
            size="md"
            buttonOkText={translateString("yes")}
            onSecondaryButtonClick={props.onDecline}
            secondaryButtonText={translateString("no")}
            open
            onDialogClose={props.onClose}
            onOkClick={props.onConfirm}
        >
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <DotLegalHeader headerStyle="small" fontWeight={0} center>
                    {translateString("addToAllDataCategoriesContent", { name: props.type?.toLowerCase() })}
                </DotLegalHeader>
            </Box>
        </DotLegalDialog>
    );
}

export default AddToAllDataCategoriesDialog;
